module.exports = __webpack_public_path__ + "assets/img/ground.6f8b0789.png";